import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgHomeIcon({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 28 28"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				d="M2.625 14L13.0713 3.55246C13.5847 3.04029 14.4153 3.04029 14.9275 3.55246L25.375 14M5.25 11.375V23.1875C5.25 23.912 5.838 24.5 6.5625 24.5H11.375V18.8125C11.375 18.088 11.963 17.5 12.6875 17.5H15.3125C16.037 17.5 16.625 18.088 16.625 18.8125V24.5H21.4375C22.162 24.5 22.75 23.912 22.75 23.1875V11.375M9.625 24.5H19.25"
				stroke={finalColor}
				strokeWidth={1.5}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
export default SvgHomeIcon;
